import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getClientSummary} from "../../services/clientService";
import Navbar from "../../components/Navbar";
import ClientReportHead from "../report/ClientReportHead";
import Category from "../report/Category";
//Mobile
import ClientReportHeadMobile from "../report/mobile/ClientReportHeadMobile";

const Scoreboard = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

   const { summary } = useSelector((state) => state.client);
    useEffect(() => {
      getClientSummary();
    }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      <Navbar />
      {windowWidth > 1200 ? <ClientReportHead /> : <ClientReportHeadMobile />}
      <Category summary={summary} />
    </div>
  );
};

export default Scoreboard;
